const SUPPORT_SOUND_DURATION_MS = 120;
const SUPPORT_SOUND_FREQUENCY = 660;
const SUPPORT_SOUND_GAIN = 0.035;
const SUPPORT_SOUND_EVENTS = ["pointerdown", "keydown", "touchstart"];

const pendingByKey = new Map();

export async function playSupportNotificationSound({ messageId, soundKey } = {}) {
  const key = messageId || soundKey || "support";
  if (pendingByKey.has(key)) return pendingByKey.get(key);

  if (hasUserInteracted()) {
    return playNow();
  }

  const promise = new Promise((resolve) => {
    const cleanup = () => {
      SUPPORT_SOUND_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onInteraction, true);
      });
      pendingByKey.delete(key);
    };
    const onInteraction = async () => {
      cleanup();
      resolve(await playNow());
    };
    SUPPORT_SOUND_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onInteraction, { once: true, capture: true });
    });
  });

  pendingByKey.set(key, promise);
  return promise;
}

function hasUserInteracted() {
  if (typeof window === "undefined") return false;
  return Boolean(window.navigator?.userActivation?.hasBeenActive);
}

async function playNow() {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return false;

    const context = new AudioContextClass();
    if (context.state === "suspended") {
      await context.resume();
    }

    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const now = context.currentTime;

    oscillator.type = "sine";
    oscillator.frequency.setValueAtTime(SUPPORT_SOUND_FREQUENCY, now);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(SUPPORT_SOUND_GAIN, now + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + SUPPORT_SOUND_DURATION_MS / 1000);

    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start(now);
    oscillator.stop(now + SUPPORT_SOUND_DURATION_MS / 1000);

    window.setTimeout(() => {
      context.close?.();
    }, SUPPORT_SOUND_DURATION_MS + 60);

    return true;
  } catch {
    return false;
  }
}
